import React, { useEffect, useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import axios from 'axios';
import SEO from '../components/SEO';
import { generateServiceAreaSchema, generateBreadcrumbSchema, generateNeighborhoodSchema, generateFAQSchema } from '../utils/schema';
import { AREA_CONTENT } from '../content/areaContent';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Mapping of combined slugs to area/neighborhood
const NEIGHBORHOOD_MAP = {
  // Queens
  'astoria-queens-ny': { area: 'queens-ny', neighborhood: 'astoria', areaName: 'Queens' },
  'flushing-queens-ny': { area: 'queens-ny', neighborhood: 'flushing', areaName: 'Queens' },
  'jamaica-queens-ny': { area: 'queens-ny', neighborhood: 'jamaica', areaName: 'Queens' },
  'forest-hills-queens-ny': { area: 'queens-ny', neighborhood: 'forest-hills', areaName: 'Queens' },
  'bayside-queens-ny': { area: 'queens-ny', neighborhood: 'bayside', areaName: 'Queens' },
  'elmhurst-queens-ny': { area: 'queens-ny', neighborhood: 'elmhurst', areaName: 'Queens' },
  'corona-queens-ny': { area: 'queens-ny', neighborhood: 'corona', areaName: 'Queens' },
  'jackson-heights-queens-ny': { area: 'queens-ny', neighborhood: 'jackson-heights', areaName: 'Queens' },
  'long-island-city-queens-ny': { area: 'queens-ny', neighborhood: 'long-island-city', areaName: 'Queens' },
  'ridgewood-queens-ny': { area: 'queens-ny', neighborhood: 'ridgewood', areaName: 'Queens' },
  'woodside-queens-ny': { area: 'queens-ny', neighborhood: 'woodside', areaName: 'Queens' },
  'rego-park-queens-ny': { area: 'queens-ny', neighborhood: 'rego-park', areaName: 'Queens' },
  'sunnyside-queens-ny': { area: 'queens-ny', neighborhood: 'sunnyside', areaName: 'Queens' },
  'kew-gardens-queens-ny': { area: 'queens-ny', neighborhood: 'kew-gardens', areaName: 'Queens' },
  'ozone-park-queens-ny': { area: 'queens-ny', neighborhood: 'ozone-park', areaName: 'Queens' },
  'howard-beach-queens-ny': { area: 'queens-ny', neighborhood: 'howard-beach', areaName: 'Queens' },
  'far-rockaway-queens-ny': { area: 'queens-ny', neighborhood: 'far-rockaway', areaName: 'Queens' },
  'whitestone-queens-ny': { area: 'queens-ny', neighborhood: 'whitestone', areaName: 'Queens' },
  'college-point-queens-ny': { area: 'queens-ny', neighborhood: 'college-point', areaName: 'Queens' },
  'fresh-meadows-queens-ny': { area: 'queens-ny', neighborhood: 'fresh-meadows', areaName: 'Queens' },
  
  // Manhattan
  'midtown-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'midtown', areaName: 'Manhattan' },
  'upper-east-side-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'upper-east-side', areaName: 'Manhattan' },
  'upper-west-side-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'upper-west-side', areaName: 'Manhattan' },
  'harlem-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'harlem', areaName: 'Manhattan' },
  'chelsea-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'chelsea', areaName: 'Manhattan' },
  'soho-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'soho', areaName: 'Manhattan' },
  'tribeca-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'tribeca', areaName: 'Manhattan' },
  'greenwich-village-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'greenwich-village', areaName: 'Manhattan' },
  'east-village-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'east-village', areaName: 'Manhattan' },
  'lower-east-side-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'lower-east-side', areaName: 'Manhattan' },
  'financial-district-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'financial-district', areaName: 'Manhattan' },
  'hells-kitchen-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'hells-kitchen', areaName: 'Manhattan' },
  'murray-hill-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'murray-hill', areaName: 'Manhattan' },
  'gramercy-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'gramercy', areaName: 'Manhattan' },
  'washington-heights-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'washington-heights', areaName: 'Manhattan' },
  'inwood-manhattan-ny': { area: 'manhattan-ny', neighborhood: 'inwood', areaName: 'Manhattan' },
  
  // Brooklyn
  'williamsburg-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'williamsburg', areaName: 'Brooklyn' },
  'park-slope-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'park-slope', areaName: 'Brooklyn' },
  'brooklyn-heights-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'brooklyn-heights', areaName: 'Brooklyn' },
  'bay-ridge-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'bay-ridge', areaName: 'Brooklyn' },
  'bushwick-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'bushwick', areaName: 'Brooklyn' },
  'crown-heights-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'crown-heights', areaName: 'Brooklyn' },
  'flatbush-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'flatbush', areaName: 'Brooklyn' },
  'greenpoint-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'greenpoint', areaName: 'Brooklyn' },
  'dumbo-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'dumbo', areaName: 'Brooklyn' },
  'bed-stuy-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'bed-stuy', areaName: 'Brooklyn' },
  'sunset-park-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'sunset-park', areaName: 'Brooklyn' },
  'bensonhurst-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'bensonhurst', areaName: 'Brooklyn' },
  'coney-island-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'coney-island', areaName: 'Brooklyn' },
  'sheepshead-bay-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'sheepshead-bay', areaName: 'Brooklyn' },
  'canarsie-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'canarsie', areaName: 'Brooklyn' },
  'brownsville-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'brownsville', areaName: 'Brooklyn' },
  'east-new-york-brooklyn-ny': { area: 'brooklyn-ny', neighborhood: 'east-new-york', areaName: 'Brooklyn' },
  
  // Bronx
  'riverdale-bronx-ny': { area: 'bronx-ny', neighborhood: 'riverdale', areaName: 'Bronx' },
  'fordham-bronx-ny': { area: 'bronx-ny', neighborhood: 'fordham', areaName: 'Bronx' },
  'pelham-bay-bronx-ny': { area: 'bronx-ny', neighborhood: 'pelham-bay', areaName: 'Bronx' },
  'throgs-neck-bronx-ny': { area: 'bronx-ny', neighborhood: 'throgs-neck', areaName: 'Bronx' },
  'kingsbridge-bronx-ny': { area: 'bronx-ny', neighborhood: 'kingsbridge', areaName: 'Bronx' },
  'parkchester-bronx-ny': { area: 'bronx-ny', neighborhood: 'parkchester', areaName: 'Bronx' },
  'mott-haven-bronx-ny': { area: 'bronx-ny', neighborhood: 'mott-haven', areaName: 'Bronx' },
  'south-bronx-ny': { area: 'bronx-ny', neighborhood: 'south-bronx', areaName: 'Bronx' },
  'morris-park-bronx-ny': { area: 'bronx-ny', neighborhood: 'morris-park', areaName: 'Bronx' },
  'westchester-square-bronx-ny': { area: 'bronx-ny', neighborhood: 'westchester-square', areaName: 'Bronx' },
  'hunts-point-bronx-ny': { area: 'bronx-ny', neighborhood: 'hunts-point', areaName: 'Bronx' },
  'concourse-bronx-ny': { area: 'bronx-ny', neighborhood: 'concourse', areaName: 'Bronx' },
  'norwood-bronx-ny': { area: 'bronx-ny', neighborhood: 'norwood', areaName: 'Bronx' },
  'tremont-bronx-ny': { area: 'bronx-ny', neighborhood: 'tremont', areaName: 'Bronx' },
  'city-island-bronx-ny': { area: 'bronx-ny', neighborhood: 'city-island', areaName: 'Bronx' },
  
  // Staten Island
  'st-george-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'st-george', areaName: 'Staten Island' },
  'tottenville-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'tottenville', areaName: 'Staten Island' },
  'great-kills-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'great-kills', areaName: 'Staten Island' },
  'new-dorp-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'new-dorp', areaName: 'Staten Island' },
  'port-richmond-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'port-richmond', areaName: 'Staten Island' },
  'stapleton-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'stapleton', areaName: 'Staten Island' },
  'eltingville-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'eltingville', areaName: 'Staten Island' },
  'annadale-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'annadale', areaName: 'Staten Island' },
  'huguenot-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'huguenot', areaName: 'Staten Island' },
  'princes-bay-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'princes-bay', areaName: 'Staten Island' },
  'rosebank-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'rosebank', areaName: 'Staten Island' },
  'grasmere-staten-island-ny': { area: 'staten-island-ny', neighborhood: 'grasmere', areaName: 'Staten Island' },
  
  // Nassau County
  'hempstead-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'hempstead', areaName: 'Nassau County' },
  'garden-city-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'garden-city', areaName: 'Nassau County' },
  'levittown-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'levittown', areaName: 'Nassau County' },
  'great-neck-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'great-neck', areaName: 'Nassau County' },
  'long-beach-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'long-beach', areaName: 'Nassau County' },
  'freeport-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'freeport', areaName: 'Nassau County' },
  'massapequa-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'massapequa', areaName: 'Nassau County' },
  'hicksville-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'hicksville', areaName: 'Nassau County' },
  'valley-stream-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'valley-stream', areaName: 'Nassau County' },
  'oceanside-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'oceanside', areaName: 'Nassau County' },
  'rockville-centre-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'rockville-centre', areaName: 'Nassau County' },
  'uniondale-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'uniondale', areaName: 'Nassau County' },
  'mineola-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'mineola', areaName: 'Nassau County' },
  'westbury-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'westbury', areaName: 'Nassau County' },
  'east-meadow-nassau-ny': { area: 'nassau-county-ny', neighborhood: 'east-meadow', areaName: 'Nassau County' },
  
  // Suffolk County
  'huntington-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'huntington', areaName: 'Suffolk County' },
  'smithtown-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'smithtown', areaName: 'Suffolk County' },
  'babylon-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'babylon', areaName: 'Suffolk County' },
  'islip-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'islip', areaName: 'Suffolk County' },
  'brookhaven-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'brookhaven', areaName: 'Suffolk County' },
  'riverhead-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'riverhead', areaName: 'Suffolk County' },
  'southampton-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'southampton', areaName: 'Suffolk County' },
  'east-hampton-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'east-hampton', areaName: 'Suffolk County' },
  'patchogue-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'patchogue', areaName: 'Suffolk County' },
  'bay-shore-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'bay-shore', areaName: 'Suffolk County' },
  'brentwood-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'brentwood', areaName: 'Suffolk County' },
  'central-islip-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'central-islip', areaName: 'Suffolk County' },
  'commack-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'commack', areaName: 'Suffolk County' },
  'deer-park-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'deer-park', areaName: 'Suffolk County' },
  'lindenhurst-suffolk-ny': { area: 'suffolk-county-ny', neighborhood: 'lindenhurst', areaName: 'Suffolk County' },
  
  // Westchester
  'yonkers-westchester-ny': { area: 'westchester-ny', neighborhood: 'yonkers', areaName: 'Westchester' },
  'white-plains-westchester-ny': { area: 'westchester-ny', neighborhood: 'white-plains', areaName: 'Westchester' },
  'new-rochelle-westchester-ny': { area: 'westchester-ny', neighborhood: 'new-rochelle', areaName: 'Westchester' },
  'mount-vernon-westchester-ny': { area: 'westchester-ny', neighborhood: 'mount-vernon', areaName: 'Westchester' },
  'scarsdale-westchester-ny': { area: 'westchester-ny', neighborhood: 'scarsdale', areaName: 'Westchester' },
  'mamaroneck-westchester-ny': { area: 'westchester-ny', neighborhood: 'mamaroneck', areaName: 'Westchester' },
  'port-chester-westchester-ny': { area: 'westchester-ny', neighborhood: 'port-chester', areaName: 'Westchester' },
  'tarrytown-westchester-ny': { area: 'westchester-ny', neighborhood: 'tarrytown', areaName: 'Westchester' },
  'ossining-westchester-ny': { area: 'westchester-ny', neighborhood: 'ossining', areaName: 'Westchester' },
  'peekskill-westchester-ny': { area: 'westchester-ny', neighborhood: 'peekskill', areaName: 'Westchester' },
  'rye-westchester-ny': { area: 'westchester-ny', neighborhood: 'rye', areaName: 'Westchester' },
  'harrison-westchester-ny': { area: 'westchester-ny', neighborhood: 'harrison', areaName: 'Westchester' },
  'eastchester-westchester-ny': { area: 'westchester-ny', neighborhood: 'eastchester', areaName: 'Westchester' },
  'dobbs-ferry-westchester-ny': { area: 'westchester-ny', neighborhood: 'dobbs-ferry', areaName: 'Westchester' },
  'bronxville-westchester-ny': { area: 'westchester-ny', neighborhood: 'bronxville', areaName: 'Westchester' },
};

// Main service area slugs
const SERVICE_AREA_SLUGS = [
  'queens-ny', 'manhattan-ny', 'brooklyn-ny', 'bronx-ny', 
  'staten-island-ny', 'nassau-county-ny', 'suffolk-county-ny', 
  'westchester-ny', 'hempstead-ny', 'long-island-ny'
];

const ServiceAreaDetail = ({ slug: slugProp }) => {
  const params = useParams();
  const slug = slugProp || params.slug;
  const [area, setArea] = useState(null);
  const [neighborhood, setNeighborhood] = useState(null);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isNeighborhood, setIsNeighborhood] = useState(false);
  const [areaSlug, setAreaSlug] = useState('');

  useEffect(() => {
    // Reset state on slug change to prevent stale renders
    setLoading(true);
    setArea(null);
    setNeighborhood(null);
    setIsNeighborhood(false);
    setAreaSlug('');
    const fetchData = async () => {
      try {
        // Check if this is a combined neighborhood slug
        const mapping = NEIGHBORHOOD_MAP[slug];
        
        if (mapping) {
          // It's a neighborhood slug - fetch neighborhood data
          setIsNeighborhood(true);
          setAreaSlug(mapping.area);
          const response = await axios.get(`${API_URL}/api/neighborhoods/${mapping.area}/${mapping.neighborhood}`);
          setNeighborhood(response.data);
        } else if (SERVICE_AREA_SLUGS.includes(slug)) {
          // It's a service area slug - fetch area data
          setIsNeighborhood(false);
          const [areaRes, servicesRes] = await Promise.all([
            axios.get(`${API_URL}/api/service-areas/${slug}`),
            axios.get(`${API_URL}/api/services?featured=true`)
          ]);
          setArea(areaRes.data);
          setServices(servicesRes.data.slice(0, 6));
        }
      } catch (err) {
        console.error('Error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [slug]);

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
    </div>
  );

  // If it's a neighborhood, render neighborhood page
  if (isNeighborhood && neighborhood) {
    const mapping = NEIGHBORHOOD_MAP[slug];
    const neighborhoodServices = [
      { name: 'Rodent Control', slug: 'rodent-control' },
      { name: 'Bed Bug Removal', slug: 'bed-bug-removal' },
      { name: 'Cockroach Extermination', slug: 'cockroach-extermination' },
      { name: 'Termite Control', slug: 'termite-control' },
      { name: 'Ant Extermination', slug: 'ant-extermination' },
      { name: 'Wasp Removal', slug: 'wasp-removal' }
    ];

    const schemas = [
      generateBreadcrumbSchema([
        { name: 'Home', url: '/' },
        { name: 'Service Areas', url: '/service-areas' },
        { name: mapping.areaName, url: `/service-areas/${mapping.area}` },
        { name: neighborhood.name, url: `/service-areas/${slug}` }
      ]),
      generateNeighborhoodSchema(neighborhood, mapping.areaName, mapping.area)
    ];

    const seoKeywords = `pest control ${neighborhood.name}, exterminator ${neighborhood.name}, ${neighborhood.name} pest removal, ${mapping.areaName} exterminator, rat exterminator ${neighborhood.name}, bed bug removal ${neighborhood.name}`;

    return (
      <div>
        <SEO 
          title={neighborhood.meta_title || `Pest Control in ${neighborhood.name}, ${mapping.areaName} | Reclaim Pest Control`}
          description={neighborhood.meta_description || `Professional pest control services in ${neighborhood.name}, ${mapping.areaName}. Expert extermination for rodents, bed bugs, roaches & more.`}
          keywords={seoKeywords}
          schema={schemas}
          canonical={`https://www.reclaimpestcontrol.com/service-areas/${slug}`}
        />

        {/* Hero Section */}
        <section className="bg-gradient-to-r from-blue-700 to-green-600 text-white py-16">
          <div className="container mx-auto px-4">
            <nav className="text-sm mb-6 text-white/80">
              <Link to="/" className="hover:text-white">Home</Link>
              <span className="mx-2">/</span>
              <Link to="/service-areas" className="hover:text-white">Service Areas</Link>
              <span className="mx-2">/</span>
              <Link to={`/service-areas/${mapping.area}`} className="hover:text-white">{mapping.areaName}</Link>
              <span className="mx-2">/</span>
              <span>{neighborhood.name}</span>
            </nav>
            
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Pest Control in {neighborhood.name}, {mapping.areaName}
            </h1>
            <p className="text-xl mb-6 max-w-3xl">
              Professional pest control services for {neighborhood.name} residents and businesses. 
              Licensed exterminators serving ZIP codes: {neighborhood.zip_codes?.join(', ')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="tel:6462099955" className="bg-white text-green-600 px-8 py-4 rounded-lg font-bold text-center hover:bg-gray-100 transition">
                Call (646) 209-9955
              </a>
              <Link to="/contact" className="bg-yellow-500 text-white px-8 py-4 rounded-lg font-bold text-center hover:bg-yellow-600 transition">
                Get Free Quote
              </Link>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: neighborhood.content }} />
                
                <div className="mt-12">
                  <h2 className="text-2xl font-bold mb-6">Pest Control Services in {neighborhood.name}</h2>
                  <div className="grid md:grid-cols-2 gap-4">
                    {neighborhoodServices.map(service => (
                      <Link 
                        key={service.slug}
                        to={`/services/${service.slug}`}
                        className="p-4 bg-gray-50 rounded-lg hover:bg-green-50 hover:shadow-md transition flex items-center"
                      >
                        <span className="text-green-600 mr-3">✓</span>
                        <span className="font-medium">{service.name}</span>
                      </Link>
                    ))}
                  </div>
                </div>
                
                <div className="mt-12 bg-blue-50 p-8 rounded-lg">
                  <h2 className="text-2xl font-bold mb-6">Why {neighborhood.name} Residents Choose Us</h2>
                  <ul className="space-y-3">
                    <li className="flex items-start"><span className="text-green-600 mr-3 mt-1">✔</span><span>Local expertise in {neighborhood.name} pest challenges</span></li>
                    <li className="flex items-start"><span className="text-green-600 mr-3 mt-1">✔</span><span>Same-day and emergency service available</span></li>
                    <li className="flex items-start"><span className="text-green-600 mr-3 mt-1">✔</span><span>Licensed, insured, NYS DEC certified</span></li>
                    <li className="flex items-start"><span className="text-green-600 mr-3 mt-1">✔</span><span>Family and pet-safe treatments</span></li>
                    <li className="flex items-start"><span className="text-green-600 mr-3 mt-1">✔</span><span>Satisfaction guaranteed</span></li>
                  </ul>
                </div>
              </div>
              
              <div className="lg:col-span-1">
                <div className="bg-green-600 text-white p-6 rounded-lg mb-6 sticky top-4">
                  <h3 className="text-xl font-bold mb-4">Free Pest Inspection</h3>
                  <p className="mb-4">Get a free inspection for your {neighborhood.name} property today!</p>
                  <a href="tel:6462099955" className="block bg-white text-green-600 px-6 py-3 rounded-lg font-bold text-center hover:bg-gray-100 transition mb-3">
                    (646) 209-9955
                  </a>
                  <Link to="/contact" className="block bg-yellow-500 text-white px-6 py-3 rounded-lg font-bold text-center hover:bg-yellow-600 transition">
                    Request Quote
                  </Link>
                </div>
                
                <div className="bg-gray-50 p-6 rounded-lg mb-6">
                  <h3 className="text-lg font-bold mb-4">Nearby Areas</h3>
                  <ul className="space-y-2 text-gray-600">
                    <li><Link to={`/service-areas/${mapping.area}`} className="hover:text-green-600">{mapping.areaName}</Link></li>
                    <li><Link to="/service-areas/queens-ny" className="hover:text-green-600">Queens, NY</Link></li>
                    <li><Link to="/service-areas/brooklyn-ny" className="hover:text-green-600">Brooklyn, NY</Link></li>
                    <li><Link to="/service-areas/manhattan-ny" className="hover:text-green-600">Manhattan, NY</Link></li>
                  </ul>
                </div>
                
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-lg font-bold mb-4">Hours</h3>
                  <p className="text-green-600 font-bold text-xl">24/7 Service</p>
                  <p className="text-gray-600 mt-2">Emergency pest control available.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-12 bg-gradient-to-r from-green-600 to-blue-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Ready to Reclaim Your {neighborhood.name} Home?</h2>
            <p className="text-xl mb-6">Call us today for fast, effective pest control.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:6462099955" className="bg-white text-green-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition">
                Call (646) 209-9955
              </a>
              <Link to="/contact" className="bg-yellow-500 text-white px-8 py-4 rounded-lg font-bold hover:bg-yellow-600 transition">
                Schedule Free Inspection
              </Link>
            </div>
          </div>
        </section>
      </div>
    );
  }
  
  // If no area found, show not found
  if (!area) return (
    <div className="container mx-auto px-4 py-16 text-center">
      <h1 className="text-2xl font-bold mb-4">Area not found</h1>
      <Link to="/service-areas" className="text-green-600 hover:underline">View all service areas</Link>
    </div>
  );

  // Build area-specific FAQs
  const areaFaqs = [
    { question: `How fast can you come to ${area.name}?`, answer: `Reclaim Pest Control offers same-day pest control service across most of ${area.name}. Call 646-209-9955 to schedule an inspection — appointments are often available the same day.` },
    { question: `Do you treat apartments in ${area.name}?`, answer: `Yes. We treat apartments, condos, co-ops, and multi-unit buildings throughout ${area.name}, working with tenants, landlords, and property managers.` },
    { question: `Do you handle roaches, rats, mice, and bed bugs in ${area.name}?`, answer: `Yes. Roaches, rats, mice, and bed bugs are among our most common ${area.name} treatments. We also handle ants, fleas, wasps, termites, and general pest issues.` },
    { question: `Do you provide commercial pest control in ${area.name}?`, answer: `Yes. We serve restaurants, food establishments, offices, retail spaces, warehouses, and property management companies in ${area.name} with commercial pest control programs.` },
    { question: `What neighborhoods of ${area.name} do you serve?`, answer: `We serve all neighborhoods of ${area.name}${area.neighborhoods && area.neighborhoods.length ? `, including ${area.neighborhoods.slice(0, 6).join(', ')}, and more` : ''}. Call 646-209-9955 to confirm service in your specific neighborhood.` }
  ];

  // Service area schemas
  const areaSchemas = [
    generateServiceAreaSchema(area),
    generateBreadcrumbSchema([
      { name: 'Home', url: '/' },
      { name: 'Service Areas', url: '/service-areas' },
      { name: area.name, url: `/service-areas/${area.slug}` }
    ]),
    generateFAQSchema(areaFaqs)
  ];

  // Rich, unique static content for this area (Queens, Brooklyn, Manhattan, Bronx, etc.)
  const content = AREA_CONTENT[area.slug];
  const heroH1 = (content && content.h1) || `Pest Control in ${area.name}, ${area.state}`;
  const heroSub = (content && content.hero_sub) || `Professional extermination services throughout ${area.name}. Licensed exterminators serving all ${area.county} neighborhoods with 24/7 emergency availability.`;

  return (
    <div>
      <SEO 
        title={(content && content.h1) ? content.h1 : area.meta_title}
        description={area.meta_description}
        keywords={area.schema_keywords?.join(', ') || `pest control ${area.name}, exterminator ${area.name}, ${area.name} pest removal`}
        schema={areaSchemas}
        canonical={`https://www.reclaimpestcontrol.com/service-areas/${area.slug}`}
      />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-700 to-green-600 text-white py-16">
        <div className="container mx-auto px-4">
          <nav className="text-sm mb-4 text-white/80">
            <Link to="/" className="hover:text-white">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/service-areas" className="hover:text-white">Service Areas</Link>
            <span className="mx-2">/</span>
            <span className="text-white">{area.name}</span>
          </nav>
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-testid="area-h1">
            {heroH1}
          </h1>
          <p className="text-xl max-w-3xl text-white/90" data-testid="area-hero-sub">
            {heroSub}
          </p>
          <div className="mt-6 flex flex-wrap gap-4">
            <a 
              href="tel:6462099955" 
              className="bg-white text-green-600 px-6 py-3 rounded-lg font-bold hover:bg-gray-100 transition flex items-center"
              data-testid="hero-call-btn"
            >
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20"><path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/></svg>
              Call (646) 209-9955
            </a>
            <Link 
              to="/contact" 
              className="bg-blue-600 text-white px-6 py-3 rounded-lg font-bold hover:bg-blue-700 transition"
              data-testid="hero-quote-btn"
            >
              Get Free Quote
            </Link>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-3 gap-12">
            {/* Left Column - Main Content */}
            <div className="lg:col-span-2 space-y-12">
              {/* Rich, unique long-form content (Queens, Brooklyn, Manhattan, Bronx) */}
              {content && content.sections && (
                <div data-testid="area-rich-content">
                  <h2 className="text-3xl font-bold mb-6">{area.name} Pest Control Services</h2>
                  {content.sections.map((s, idx) => (
                    <div key={idx} className="mb-8">
                      <h2 className="text-2xl md:text-3xl font-bold mb-3 text-gray-900">{s.h2}</h2>
                      <p className="text-base md:text-lg text-gray-700 leading-relaxed">{s.body}</p>
                    </div>
                  ))}
                  {content.cta && (
                    <div className="bg-green-50 border-l-4 border-green-600 p-5 rounded my-8" data-testid="area-mid-cta">
                      <p className="text-base md:text-lg font-semibold text-gray-900 mb-3">{content.cta}</p>
                      <a href="tel:6462099955" className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold px-6 py-3 rounded-lg transition" data-testid="area-mid-call-btn">
                        Call 646-209-9955
                      </a>
                    </div>
                  )}
                </div>
              )}

              {/* Fallback: API-provided description (only if no static content) */}
              {!content && (
                <div>
                  <h2 className="text-3xl font-bold mb-6">{area.name} Pest Control Services</h2>
                  <p className="text-lg text-gray-700 leading-relaxed mb-6">{area.description}</p>
                  {area.seo_content && (
                    <p className="text-gray-600 leading-relaxed">{area.seo_content}</p>
                  )}
                </div>
              )}

              {/* Common Pests */}
              {area.common_pests && area.common_pests.length > 0 && (
                <div className="bg-red-50 p-8 rounded-lg">
                  <h2 className="text-2xl font-bold mb-4 text-red-800">Common Pests in {area.name}</h2>
                  <p className="text-gray-700 mb-4">Residents and businesses in {area.name} commonly face these pest problems:</p>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {area.common_pests.map((pest, idx) => (
                      <div key={idx} className="bg-white p-4 rounded-lg text-center shadow-sm">
                        <span className="text-2xl mb-2 block">
                          {pest === 'Mice' && '🐭'}
                          {pest === 'Rats' && '🐀'}
                          {pest === 'Bed Bugs' && '🛏️'}
                          {pest === 'Cockroaches' && '🪳'}
                          {pest === 'Ants' && '🐜'}
                          {pest === 'Termites' && '🪵'}
                          {pest === 'Wasps' && '🐝'}
                          {pest === 'Flies' && '🪰'}
                          {pest === 'Spiders' && '🕷️'}
                          {pest === 'Ticks' && '🎯'}
                          {pest === 'Mosquitoes' && '🦟'}
                          {pest === 'Wildlife' && '🦝'}
                          {!['Mice', 'Rats', 'Bed Bugs', 'Cockroaches', 'Ants', 'Termites', 'Wasps', 'Flies', 'Spiders', 'Ticks', 'Mosquitoes', 'Wildlife'].includes(pest) && '🐛'}
                        </span>
                        <span className="font-medium text-gray-800">{pest}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Neighborhoods We Serve */}
              {area.neighborhoods && area.neighborhoods.length > 0 && (
                <div>
                  <h2 className="text-2xl font-bold mb-6">{area.name} Neighborhoods We Serve</h2>
                  <p className="text-gray-600 mb-6">
                    Our licensed exterminators provide professional pest control throughout {area.name}, including these neighborhoods and surrounding areas:
                  </p>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    {area.neighborhoods.map((neighborhood, idx) => (
                      <div 
                        key={idx} 
                        className="bg-blue-50 p-3 rounded-lg text-center hover:bg-blue-100 transition"
                      >
                        <span className="font-medium text-blue-800">{neighborhood}</span>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-gray-500 mt-4">
                    Don&apos;t see your neighborhood? We likely serve your area! Call us at (646) 209-9955 to confirm service availability.
                  </p>
                </div>
              )}

              {/* Why Choose Us */}
              <div className="bg-gray-50 p-8 rounded-lg">
                <h2 className="text-2xl font-bold mb-6">Why Choose Reclaim Pest Control in {area.name}?</h2>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="flex items-start">
                    <span className="bg-green-100 text-green-600 p-2 rounded-lg mr-4">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                    </span>
                    <div>
                      <h3 className="font-bold mb-1">Local {area.name} Experts</h3>
                      <p className="text-gray-600 text-sm">We know the specific pest challenges in {area.county} and how to solve them</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <span className="bg-green-100 text-green-600 p-2 rounded-lg mr-4">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </span>
                    <div>
                      <h3 className="font-bold mb-1">Same-Day Service</h3>
                      <p className="text-gray-600 text-sm">Emergency pest control available 24/7 for urgent infestations</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <span className="bg-green-100 text-green-600 p-2 rounded-lg mr-4">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
                    </span>
                    <div>
                      <h3 className="font-bold mb-1">Licensed & Insured</h3>
                      <p className="text-gray-600 text-sm">Fully certified technicians with comprehensive coverage</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <span className="bg-green-100 text-green-600 p-2 rounded-lg mr-4">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg>
                    </span>
                    <div>
                      <h3 className="font-bold mb-1">Eco-Friendly Options</h3>
                      <p className="text-gray-600 text-sm">Safe treatments for families, pets, and the environment</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <span className="bg-green-100 text-green-600 p-2 rounded-lg mr-4">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </span>
                    <div>
                      <h3 className="font-bold mb-1">Satisfaction Guaranteed</h3>
                      <p className="text-gray-600 text-sm">We stand behind our work with guaranteed results</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <span className="bg-green-100 text-green-600 p-2 rounded-lg mr-4">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                    </span>
                    <div>
                      <h3 className="font-bold mb-1">Competitive Pricing</h3>
                      <p className="text-gray-600 text-sm">Affordable rates with free inspections and quotes</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Services We Offer */}
              <div>
                <h2 className="text-2xl font-bold mb-6">Pest Control Services in {area.name}</h2>
                <div className="grid md:grid-cols-2 gap-4">
                  {services.map(service => (
                    <Link 
                      key={service.id} 
                      to={`/services/${service.slug}`}
                      className="flex items-center p-4 bg-white border rounded-lg hover:border-green-500 hover:shadow-md transition group"
                      data-testid={`service-link-${service.slug}`}
                    >
                      <div className="flex-1">
                        <h3 className="font-bold group-hover:text-green-600 transition">{service.name}</h3>
                        <p className="text-sm text-gray-600 line-clamp-1">{service.short_description}</p>
                      </div>
                      <svg className="w-5 h-5 text-gray-400 group-hover:text-green-600 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                    </Link>
                  ))}
                </div>
                <div className="mt-6 text-center">
                  <Link to="/services" className="text-green-600 font-medium hover:underline">View All Services →</Link>
                </div>
              </div>
            </div>

            {/* Right Column - Sidebar */}
            <div className="lg:col-span-1">
              <div className="sticky top-24 space-y-6">
                {/* Contact CTA */}
                <div className="bg-green-600 text-white p-6 rounded-lg">
                  <h3 className="text-xl font-bold mb-3">Get Pest-Free Today!</h3>
                  <p className="text-white/90 mb-4 text-sm">Serving {area.name} 24/7. Fast response, guaranteed results.</p>
                  <a 
                    href="tel:6462099955" 
                    className="block bg-white text-green-600 text-center py-3 rounded-lg font-bold mb-3 hover:bg-gray-100 transition"
                    data-testid="sidebar-call-btn"
                  >
                    <span className="flex items-center justify-center">
                      <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20"><path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/></svg>
                      (646) 209-9955
                    </span>
                  </a>
                  <Link 
                    to="/contact" 
                    className="block bg-blue-600 text-center py-3 rounded-lg font-bold hover:bg-blue-700 transition"
                    data-testid="sidebar-quote-btn"
                  >
                    Request Free Quote
                  </Link>
                </div>

                {/* Other Service Areas */}
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="font-bold mb-4">Other Service Areas</h3>
                  <ul className="space-y-2 text-sm">
                    {['queens-ny', 'manhattan-ny', 'brooklyn-ny', 'bronx-ny', 'nassau-county-ny', 'suffolk-county-ny'].filter(s => s !== slug).slice(0, 5).map(areaSlug => {
                      const names = {
                        'queens-ny': 'Queens, NY',
                        'manhattan-ny': 'Manhattan, NY',
                        'brooklyn-ny': 'Brooklyn, NY',
                        'bronx-ny': 'Bronx, NY',
                        'nassau-county-ny': 'Nassau County',
                        'suffolk-county-ny': 'Suffolk County'
                      };
                      return (
                        <li key={areaSlug}>
                          <Link to={`/service-areas/${areaSlug}`} className="text-gray-700 hover:text-green-600 flex items-center">
                            <svg className="w-4 h-4 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/></svg>
                            {names[areaSlug]}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                  <Link to="/service-areas" className="text-green-600 text-sm font-medium mt-4 block hover:underline">
                    View All Areas →
                  </Link>
                </div>

                {/* Trust Badges */}
                <div className="bg-white border rounded-lg p-6">
                  <h3 className="font-bold mb-4 text-center">Why Trust Us</h3>
                  <div className="space-y-3 text-sm">
                    <div className="flex items-center">
                      <span className="text-green-500 mr-2">✓</span>
                      Licensed & Insured
                    </div>
                    <div className="flex items-center">
                      <span className="text-green-500 mr-2">✓</span>
                      Eco-Friendly Options
                    </div>
                    <div className="flex items-center">
                      <span className="text-green-500 mr-2">✓</span>
                      24/7 Emergency Service
                    </div>
                    <div className="flex items-center">
                      <span className="text-green-500 mr-2">✓</span>
                      Satisfaction Guaranteed
                    </div>
                    <div className="flex items-center">
                      <span className="text-green-500 mr-2">✓</span>
                      Free Inspections
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 text-center">
              Pest Control in {area.name} — FAQs
            </h2>
            <p className="text-center text-gray-600 mb-8">Quick answers about pest control service in {area.name}.</p>
            <div className="space-y-3" data-testid="area-faq-list">
              {areaFaqs.map((faq, idx) => (
                <details key={idx} className="bg-gray-50 border border-gray-200 rounded-lg group" data-testid={`area-faq-${idx}`}>
                  <summary className="cursor-pointer px-5 py-4 font-semibold text-gray-900 hover:bg-gray-100 transition list-none flex items-center justify-between">
                    <span>{faq.question}</span>
                    <span className="text-green-600 text-xl group-open:rotate-45 transition-transform">+</span>
                  </summary>
                  <div className="px-5 pb-5 text-gray-700 border-t border-gray-200">
                    <p className="pt-3">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready for a Pest-Free {area.name}?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto text-white/90">
            Contact Reclaim Pest Control today for professional pest control services in {area.name} and all of {area.county}.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:6462099955" 
              className="bg-green-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-green-600 transition"
              data-testid="cta-call-btn"
            >
              Call (646) 209-9955
            </a>
            <Link 
              to="/contact" 
              className="bg-white text-blue-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition"
              data-testid="cta-quote-btn"
            >
              Schedule Free Inspection
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceAreaDetail;
